var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReview2 = function SvgIconReview2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEECFF",
    stroke: "#DEECFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.889,
    d: "M27.778 9a2.89 2.89 0 0 0-2.89 2.889v8.667a2.89 2.89 0 0 0 2.89 2.888 1.444 1.444 0 0 1 1.444 1.445v1.444a2.89 2.89 0 0 1-2.889 2.89 1.444 1.444 0 0 0-1.444 1.444v2.889A1.444 1.444 0 0 0 26.333 35 8.667 8.667 0 0 0 35 26.333V11.89A2.89 2.89 0 0 0 32.111 9zM11.889 9A2.89 2.89 0 0 0 9 11.889v8.667a2.89 2.89 0 0 0 2.889 2.888 1.444 1.444 0 0 1 1.444 1.445v1.444a2.89 2.89 0 0 1-2.889 2.89A1.444 1.444 0 0 0 9 30.666v2.889A1.444 1.444 0 0 0 10.444 35a8.667 8.667 0 0 0 8.667-8.667V11.89A2.89 2.89 0 0 0 16.222 9z"
  })));
};
export default SvgIconReview2;